module.exports = __webpack_public_path__ + "static/media/Productivity.75e12e2e.svg";